import React from 'react';
import { getText } from '../../utils/functions';
import { useDownloadDocument, useIcons } from '../../utils/hooks';

function FileButton({
	style,
	file,
	text,
	colors,
	translate,

	/* OPTIONAL PROPS */
	classNameBTN = 'flex focus:outline-none w-max align-middle items-center space-x-4 md:pl-2',
	classNameIMG = 'w-7 h-7',
	classNameTXT = 'text-left',
	disabled,
}) {
	/* Variable that checks if any point of the component is being hovered so style can be applied to the Box */
	const [hover, setHover] = React.useState(false);

	/* Icon hook */
	const { Document } = useIcons(colors);

	/* Custom hook to download selected document */
	const [downloading, download] = useDownloadDocument();

	/* Default values for the styles */
	const defaultStyle = {
		backgroundColor: hover ? colors?.light : colors?.background,
		color: colors?.text,
		cursor: downloading ? 'wait' : 'pointer',
		transition: 'all 100ms ease-in',
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyle = { ...defaultStyle, ...style };

	/* Mouseover Styling */
	const onMouseOver = () => setHover(true);
	const onMouseLeave = () => setHover(false);


	const onClick = async event => {
		event.preventDefault();
		await download(null, file);
	};

	return (
		<button
			className={classNameBTN}
			onClick={onClick}
			disabled={disabled}
			style={overrideStyle}
			onMouseOver={onMouseOver}
			onMouseLeave={onMouseLeave}
			type = "button"
		>
			{Document({ className: classNameIMG })}
			{file?.filename
			&& <span className={classNameTXT}>
				{getText(text, translate) || file?.filename}
			</span>}
		</button>
	);
}

export default FileButton;
